import React from "react";
import { ButtonProps } from "react-bootstrap";
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import Btn from './Button';

export interface IconButtonProps extends ButtonProps {
    text?: string
    icon: string
    appFunction?: ApplicationFunctions
    onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

const IconButton: React.FC<IconButtonProps> = ({ text, icon, appFunction, disabled, variant, onClick }) => {
    const { isAuthorizedFor } = useAuth();

    if (appFunction && !isAuthorizedFor(appFunction))
        return <></>;

    if (!variant)
        variant = 'secondary'

    return (
        <Btn text={text} type={'button'} fill variant={variant} disabled={disabled} onClick={onClick}><i className={'fa ' + icon}/></Btn>
    );
}
export default IconButton;